import React, {Component} from 'react';
import PropTypes from 'prop-types';
import validator from "validator";
import TimePicker from "rc-time-picker";
import moment from "moment";
import classnames from "classnames";
import {connect} from "react-redux";
import {cancelBook, updateBook} from "../../store/actions/book";
import {setErrors} from "../../store/actions/error";


const format = 'hh:mm A';

class EditBooking extends Component {
  constructor(props) {
    super(props);
    const {po_number, truck_number, start, end} = this.props.eventInfo;
    this.state = {
      docker: {
        value: props.warehouse.warehouse_docks.filter(dock => dock.id === this.props.eventInfo.dock)[0].id
      },
      poNumber: {
        value: po_number,
        isValid: true,
        touched: false
      },
      truckNumber: {
        value: truck_number,
        isValid: true,
        touched: false
      },
      from: {
        value: moment(start),
        isValid: true,
        touched: false
      },
      to: {
        value: moment(end),
        isValid: true,
        touched: false
      },
      formValid: true
    };
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(ev) {
    const name = ev.target.name;
    const value = ev.target.value;

    this.setState({
      [name]: {
        ...this.state[name],
        value
      }
    }, () => this.validateField(name, value));
  }

  validateField(fieldName, value) {
    let isValid = !validator.isEmpty(value);

    this.setState({
      [fieldName]: {
        ...this.state[fieldName],
        isValid
      }
    }, this.validateForm);
  }

  onTimeChange(value, field) {
    this.props.setErrors(null);
    let isValid = this.state[field].isValid;
    let touched = false;


    if (field === 'from') {
      isValid = !!value;
    } else {
      const {from} = this.state;

      isValid = value.isAfter(from.value);
      touched = true;
    }

    this.setState({
      [field]: {
        ...this.state[field],
        value,
        isValid,
        touched
      }
    }, this.validateForm);
  }

  validateForm() {
    const {truckNumber, poNumber, to, from} = this.state;
    this.setState({
      formValid: truckNumber.isValid && poNumber.isValid && to.isValid && from.isValid
    });
  }

  handleDockerChange(ev) {
    const docker = ev.target.value;

    this.setState({
      docker
    });
  }

  cancelBook() {
    const {eventInfo} = this.props;

    this.props.cancelBook(eventInfo.id, this.props.onModalClose);
  }

  onSubmit(e) {
    e.preventDefault();

    if (this.state.formValid) {
      const {docker, from, to} = this.state;
      const {eventInfo, onModalClose} = this.props;
      const body = {
        dock_to: docker.value,
        old_end_date: eventInfo.end_date,
        dock_from: eventInfo.dock,
        new_end_date: to.value.format(),
        old_start_date: eventInfo.start_date,
        booked_dock: eventInfo.id,
        new_start_date: from.value.format()
      };

      this.props.updateBook(body, onModalClose);
    }
  }

  render() {
    const {onModalClose, warehouse, errors} = this.props;
    const {poNumber, truckNumber, formValid, to, from, docker} = this.state;
    const dockers = (
        <select className="form-control" name="warehouse" value={docker.value} onChange={this.handleDockerChange.bind(this)}>
          {warehouse.warehouse_docks.map(wh => (<option key={wh.id} value={wh.id}>{wh.name}</option>))}
        </select>
    );

    return (
        <div className="popup">
          <div className="btn-close">
            <button onClick={onModalClose} className="btn btn-link"><i
                className="icon-close"> </i></button>
          </div>
          <div className="container">
            <div className="row justify-content-center">
              <form className="col-md-8" onSubmit={this.onSubmit.bind(this)}>
                <div className="form-title">
                  <h1>Edit booking</h1>
                </div>
                <div className="form-group">
                  <label htmlFor="city">Docker</label>
                  {dockers}
                </div>
                <div className="row">
                  <div className="col">
                    <div className="form-group">
                      <label>From</label>
                      <TimePicker
                          showSecond={false}
                          className="form-control"
                          format={format}
                          use12Hours
                          value={from.value}
                          onChange={value => this.onTimeChange(value, 'from')}
                      />
                    </div>
                  </div>
                  <div className="col">
                    <div className={classnames('form-group', {'invalid': (!to.isValid && to.touched) || errors})}>
                      <label>To</label>
                      <TimePicker
                          showSecond={false}
                          className="form-control"
                          format={format}
                          use12Hours
                          inputReadOnly
                          value={to.value}
                          onChange={value => this.onTimeChange(value, 'to')}
                          disabled={!from.value}
                      />
                      {!to.isValid && to.touched && (<p className="error-msg">Please select valid time.</p>)}
                      {errors && (<p className="error-msg">The docker is already booked for this time.</p>)}
                    </div>
                  </div>
                </div>
                <div className="form-group">
                  <input type="text" className="form-control" placeholder="PO number" name="poNumber"
                         value={poNumber.value} onChange={this.handleChange}/>
                </div>
                <div className="form-group">
                  <input type="text" className="form-control" placeholder="Truck number" name="truckNumber"
                         value={truckNumber.value} onChange={this.handleChange}/>
                </div>
                <div className="form-group text-right">
                  <button type="button" className="btn no-padding btn-link" onClick={this.cancelBook.bind(this)}>Cancel
                    booking
                  </button>

                </div>
                <div className="form-group text-right mb-4">
                  <button onClick={onModalClose} type="button" className="btn btn-lg btn-secondary mr-3">Cancel
                  </button>
                  <input type="submit" className="btn btn-lg btn-primary" value="Save" disabled={!formValid}/>
                </div>
              </form>
            </div>
          </div>
        </div>
    );
  }
}

EditBooking.propTypes = {
  onModalClose: PropTypes.func.isRequired,
  eventInfo: PropTypes.object,
  warehouse: PropTypes.object,
  cancelBook: PropTypes.func.isRequired,
  updateBook: PropTypes.func.isRequired,
  setErrors: PropTypes.func.isRequired,
  errors: PropTypes.any
};

const initMapDispatchToProps = dispatch => ({
  cancelBook: (id, closeModal) => dispatch(cancelBook(id, closeModal)),
  updateBook: (body, closeModal) => dispatch(updateBook(body, closeModal)),
  setErrors: errors => dispatch(setErrors(errors))
});

const initMapStateToProps = state => ({
  errors: state.error.errors
});

export default connect(initMapStateToProps, initMapDispatchToProps)(EditBooking);



// WEBPACK FOOTER //
// ./src/components/popups/EditBooking.jsx